// Adds Tailwind variables to the global scope
import "./setup/tailwind-setup.js";

// Import JavaScript components
// import './components/accordion';
// import './components/tabs';
// import './components/toggle';
import "./components/parallax.mjs";

//If you want cookie consent
// import "./modules/cookie-consent";

//If you need a class to be toggled on a different element
// import "./modules/toggle";

//If you need to do something when its in/out of the viewport
// import "./modules/intersects";

{
	const constrain = (minimum, maximum, value) => Math.min(Math.max(value, minimum), maximum);

	const html = document.querySelector("html");
	if (html instanceof HTMLElement) {
		/** Main menu button */
		{
			const hamburger = document.querySelector("#hamburger");
			if (hamburger instanceof HTMLElement) {
				hamburger.addEventListener("click", (_) => {
					html.classList.toggle("main-menu-active");
					hamburger.ariaLabel = html.classList.contains("main-menu-active") ? "Close menu" : "Open menu";
				});
				const mobile_menu = document.querySelector(".group\\/mobile-menu");
				if (mobile_menu instanceof HTMLElement) {
					html.addEventListener("click", (ev) => {
						const target = ev?.target;
						if (target instanceof HTMLElement && !hamburger.contains(target) && !mobile_menu.contains(target)) {
							html.classList.remove("main-menu-active");
							hamburger.ariaLabel = "Open menu";
						}
					});
				}
			}
		}

		/** Hide on scroll. */
		{
			const tailwind_theme = (await import("../../tailwind.theme.config.js")).default;
			const header_height_a = tailwind_theme.extend.header.height[0],
				header_height_b = tailwind_theme.extend.header.height["xl"],
				screen_width_a = 375,
				screen_width_b = 1440,
				hide_on_scroll_elements = document.querySelectorAll(".hide-on-scroll");
			const slope = (header_height_b - header_height_a) / (screen_width_b - screen_width_a);
			const header_height_fn = () =>
				constrain(header_height_a, header_height_b, slope * window.innerWidth + (header_height_a - slope * screen_width_a));
			if (hide_on_scroll_elements !== null) {
				let scroll_y = window.scrollY,
					position = 0;
				const set_position = (value) => {
					position = constrain(-header_height_fn(), 0, value);
					if (!html.classList.contains("main-menu-active"))
						html.style.setProperty("--hide-on-scroll-translate-y", `${position}px`);
				};
				window.addEventListener("scroll", (_) => {
					html.classList.add("scrolling");
					set_position(position - (window.scrollY - scroll_y));
					scroll_y = window.scrollY;
				});
				window.addEventListener("scrollend", (_) => {
					html.classList.remove("scrolling");
					const header_height = -header_height_fn();
					set_position(position > header_height / 2 ? 0 : header_height);
				});
			}
		}
	}

	/** Smooth scroll with focus */
	document.querySelectorAll('a[href^="#"]').forEach((anchor) => {
		anchor.addEventListener("click", function (e) {
			e.preventDefault();

			const el = document.querySelector(this.getAttribute("href"));

			el.scrollIntoView({
				behavior: "smooth",
			});

			// Put the focus on the element after scrolling for screen readers
			el.focus();
		});
	});
}
